import { render } from "./DeleteConfirmationModalComponent.vue?vue&type=template&id=21635129&ts=true"
import script from "./DeleteConfirmationModalComponent.vue?vue&type=script&lang=ts"
export * from "./DeleteConfirmationModalComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__